<script>
export default {
  props: {
    title: String,
    titleT: String,
    faIcon: String,
    href: String,
    classMenu: { type: String, default: '' },
    target: { type: String, default: '' },
    hideTitle: { type: Boolean, default: false },
  },

  computed: {
    titleComputed: function () {
      if (this.titleT) {
        return this.$t(this.titleT)
      }
      return this.title
    },
  },
}
</script>
<template>
  <li :class="['menu-item', classMenu]" :title="titleComputed">
    <a class="menu-link" :href="href" :target="target">
      <span v-if="faIcon" :class="['fa', faIcon]"></span>
      <span class="title" v-html="titleComputed"></span>
    </a>
  </li>
</template>
